module.exports = __webpack_public_path__ + "static/media/big_hand.151dfc56.gif";